/* eslint-disable array-callback-return */
/* eslint-disable no-self-compare */
/* eslint-disable complexity */
/**
 * 聊天消息项组件
 * @author sunzhiguang
 * @date 2020/6/10
 */
import React, { ReactNode } from "react";
import "./index.less";
import ChatState, { UserState } from "@/types/chat/State";
import {
  ChatMessage,
  ChatMessageType,
  Employee,
  MessageStatus,
  ChatMessagePlusEmitBody,
  Session,
  ClientType
} from "@/types/chat";
import { connect } from "dva";
import { sf } from "@/utils/date";
import { Checkbox, Dropdown, Menu, message as toast, Tooltip } from "antd";
import { WithTranslation, withTranslation } from "react-i18next";
import SessionType from "@jd/jdee.im.sdk/lib/es/enum/SessionType";
import { HeadShowType, MessageSendType } from "@/types/chat/enum";
import classNames from "classnames";
import Control from "@/components/chat/message/Item/Control";
import HeadPortrait from "@/baseComponents/Chat/HeadPortrait";
import Revoke from "@/components/chat/message/Revoke";
import Text from "@/components/chat/message/Text";
import HttpCard from "@/components/chat/message/HttpCard";
import Image from "@/components/chat/message/Image";
import UploadFile from "@/baseComponents/Chat/message/File/Upload";
import DownloadFile from "@/baseComponents/Chat/message/File/Download";
import Video from "@/components/chat/message/Video";
import Voice from "@/components/chat/message/Voice";
import Share from "@/components/chat/message/share";
import JoyspaceFile from "@/components/chat/message/message-components/JoyspaceFile";
import NoticeCard from "@/components/chat/message/NoticeCard";
import AINoticeCard from "@/components/chat/message/AINoticeCard";
import Location from "@/components/chat/message/Location";
import {
  checkMessageSupport,
  getMessageSendType,
  isCardViewGroupSession,
  isEqualEmployee,
  isGroupChatVisibleUnit,
  isGroupvisiblePost,
  isSameClient,
  isShowFakeNoticeCard,
  isShowOldNoticeCard,
  uidToEmployee,
  getVoiceMsgWidth,
  isTemp2CommonCardMsg,
  isQuillMsg,
  showIntentRootTail,
  isOrgNoticeImageTextCardMessage
} from "@/utils/chat/message";
import UnSupport from "@/components/chat/message/UnSupport";
import { UserCardPayload } from "@/models";
import { FocusSDK, getClientType, isFocusEnv } from "@/utils";
import SysMessage from "@/components/chat/message/Sys";
import { cancelMergeTag, LiveStatusTag, UserTag } from "@/components/Tags";
import { UserCardType } from "@/types/UserCard";
import { GroupRosterIdentity } from "@jd/jdee.im.sdk/lib/es/model/Roster";
import { getUserAlias, isGroupOrdinary } from "@/utils/chat/group";
import Bus from "@/utils/bus";
import MessageControl from "@/components/chat/message/MsgControl";
import ChatAggregation from "../../message/ChatAggregation/index";
import CountDown from "../CountDown";
import { isAIChatSession, isAINoticeSession, isOrgChatSession } from "@/utils/chat/session";
import GroupNotificationCard from "../GroupNotificationCard";
import SolitaireCard from "../SolitaireCard";
import ImService from "@/server/ImService";
import { analysisLog } from "@/utils/logAnalytics";
import ComGroupAlias from "@/baseComponents/ComGroupAlias";
import JoyspaceFolder from "../message-components/JoyspaceFolder";
import { isMeetingInviteMsg } from "@/baseComponents/Meeting/utils";
import MeetingInviteCard from "../Text/MeetingInviteCard";
import QuestionControl from "@/baseComponents/Chat/QuestionControl";
import Meeting from "@/pagesv2/Meeting";
import { isShareHintMultiMessage } from "@/utils/chat";
import { tagsNode } from "@/components/AddressBook/common";
import QuickReplyCard from "@/baseComponents/Chat/message/QuickReplyCard";
import ReplyEmojiCard from "@/baseComponents/Chat/message/ReplyEmojiCard";
import DotLoading from "@/baseComponents/DotLoading";
import AiIntentTail from "@/baseComponents/Chat/AIIntentTail";
import AiLoading from "@/baseComponents/Chat/AILoading";
import IconFont from "@/components/icon";
import UploadWithDetailBtn from "@/baseComponents/Chat/message/File/UploadWithDetailBtn";
import MessageDongReadStatusBtn from "./MessageDongReadStatusBtn";
interface MessageItemProps {
  sendTime: React.ReactElement;
  message: ChatMessage & ChatMessagePlusEmitBody;
  groupRosterIdentity: GroupRosterIdentity | "";
  prevMessage: ChatMessage | null;
  getCurrentMessageId: Function;
  setCurrentMessageId: Function;
  unLock: Function;
  getLock: (lock?: boolean) => boolean;
  members: Employee[];
  sText?: string;
  sMid?: number;
  refreshMessageBox: any;
  updateSessionMessageMid: Function;
  dealStopQuestions: Function;
  updateSessionMessagesTimestamp: Function;
  shareRecords?: boolean;
  isLiveMeetingChat?: boolean;
  isInviteForward?: boolean;
  modalMessages?: ChatMessage[];
  // io: any;
}
interface OwnState {
  avatarRightClick: boolean;
  showOperate: boolean;
  messageExtend: any;
  beginSend: boolean;
  selectChatItem: boolean;
  hasEmoji: boolean;
  visible: boolean;
  hasReachedMax: boolean;
}

interface DvaDispatchProps {
  deleteSessionMessage: (data: { message: ChatMessage }) => void;
  toggleUserCardModal: (payload: UserCardPayload) => void;
  getEbookDeptInfo: (params: any) => void;
  updateMessages: (data: { messages: ChatMessage[] }) => void;
}

type IProps = Readonly<
  MessageItemProps & ChatState & DvaDispatchProps & UserState & WithTranslation
>;
class ChatItem extends React.Component<IProps, OwnState> {
  wrapRef: any;
  animation: any;
  _scrollContainer: HTMLElement | null | undefined;
  // eslint-disable-next-line @typescript-eslint/member-ordering
  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    // 该方法内禁止访问thisx
    if (nextProps.selectMore) {
      // 通过对比nextProps和prevState，返回一个用于更新状态的对象
      return {
        showOperate: false
      };
    } else {
      return {
        selectChatItem: false
      };
    }
    // 不需要更新状态，返回null
    // return null;
  }
  constructor(props: IProps) {
    super(props);
    this.state = {
      avatarRightClick: false,
      showOperate: false,
      messageExtend: {},
      beginSend: false,
      selectChatItem: !!props.messages.find((i) => i.id === props.message.id),
      hasEmoji: false,
      visible: false,
      hasReachedMax: false
    };
    this.wrapRef = React.createRef();
  }
  // 页面或容器滚动时关闭 Dropdown
  handleScrollClose = () => {
    const { visible, avatarRightClick } = this.state;
    if (visible || avatarRightClick) {
      this.setState({ visible: false, avatarRightClick: false });
    }
    Bus.emit("chat-container-scroll");
  };
  componentDidMount() {
    Bus.on("message-item-chatitem", this.visibleChange);
    Bus.on("chat:clearSelect", this.addclearSelectListener);
    // Bus.on('contextmenu:message-operate:hide', this.handleVisible);
    // 只有io不为空
    const { message, selectedSession } = this.props;
    Bus.on(
      `chat:message-quick-reply:${selectedSession.sessionId}:${message.mid}`,
      this.handleQuickChange
    );
    Bus.on(
      `chat:message-reply-emoji:${selectedSession.sessionId}:${message.mid}`,
      this.handleQuickChange
    );
    const scrollEle = document.getElementById("message-box-container-scroll");
    let io: any;
    if (scrollEle) {
      io = selectedSession?.isSecret
        ? new IntersectionObserver((entries) => this.getMessages(io, entries), {
            root: scrollEle,
            threshold: [0.5]
          })
        : null;
    }
    if (io) {
      const element = document.getElementById(`item-${message.id}-${message.timestamp}`);
      // console.log('element', element);
      // 有消息且消息是对方发的文本消息才会做可视区域监听
      if (element && this.isVisibleOfText()) {
        // console.log('对方发的监听');
        io.observe(element);
      }
    }

    // 监听全局滚动（捕获阶段，能捕获任意滚动）
    // window.addEventListener('scroll', this.handleScrollClose, true);
    // 监听消息容器滚动
    this._scrollContainer = document.getElementById('message-box-container-scroll');
    if (this._scrollContainer) {
      this._scrollContainer.addEventListener('scroll', this.handleScrollClose, { passive: true } as any);
    }

    if (this.wrapRef.current) {
      const wrapWidth = this.wrapRef.current.offsetWidth;
      const targetElement = this.wrapRef.current.querySelector('.row-item-wrap');

      if (targetElement) {
        const targetWidth = targetElement.offsetWidth;
        const maxWidth = wrapWidth - 220;
        const hasReachedMax = targetWidth >= maxWidth;
        this.setState({
          hasReachedMax: hasReachedMax
        });
      }
    }
  }
  componentWillUnmount() {
    const { message, selectedSession } = this.props;
    Bus.off("message-item-chatitem", this.visibleChange);
    Bus.off("chat:clearSelect", this.addclearSelectListener);
    Bus.off(
      `chat:message-quick-reply:${selectedSession.sessionId}:${message.mid}`,
      this.handleQuickChange
    );
    Bus.off(
      `chat:message-reply-emoji:${selectedSession.sessionId}:${message.mid}`,
      this.handleQuickChange
    );
    // Bus.off('contextmenu:message-operate:hide', this.handleVisible);
    // 取消滚动监听
    // window.removeEventListener('scroll', this.handleScrollClose, true);
    if (this._scrollContainer) {
      this._scrollContainer.removeEventListener('scroll', this.handleScrollClose as any);
    }
    this.setState = (state, callback) => {
      return;
    };
  }
  visibleChange = (visible: any) => {
    if (visible) {
      this.setState({ visible: false });
      this.maskShow();
    }
  };
  addclearSelectListener = (params: any) => {
    if (params.clearSelect) {
      this.setState({
        selectChatItem: false
      });
    }
  };

  getMessages = (io: any, entries: any[]) => {
    const { updateSessionMessageMid, updateSessionMessagesTimestamp } = this.props;
    const imService = ImService.getInstance();
    // console.log('entries', entries);
    entries.forEach(async (entry) => {
      if (entry.isIntersecting) {
        // 当前元素可见 设置消息读取时间
        const message = JSON.parse(entry.target.dataset.message);
        // console.log('可见元素', message);
        if (!message.readTimeOfMessage) {
          const readTimeOfMessage = new Date().getTime();
          const result = await imService?.updateReadTime(message.sessionId, message.mid, {
            ...message,
            readTimeOfMessage
          });
          if (result) {
            await updateSessionMessageMid({
              sessionId: message.sessionId,
              sendResult: {
                body: { ...message, readTimeOfMessage }
              }
            });
            await updateSessionMessagesTimestamp({
              timestamp: new Date().getTime()
            });
          }
          io?.unobserve(entry.target); // 停止观察当前元素 避免不可见时候再次调用callback函数
        }
      }
    });
  };

  isVisibleOfText() {
    const { message } = this.props;
    const sendType = this.getSendType();
    if (sendType === MessageSendType.OTHER) {
      return message.type === ChatMessageType.TEXT && message?.expire;
    }
    return false;
  }
  getSendUserName() {
    const { selectedSession: session, message, currentEmployee } = this.props;
    const titleName =
      isGroupvisiblePost(session) && message.sender.titleName
        ? `-${message.sender.titleName}`
        : null;
    if (session.sessionType === SessionType.GROUP) {
      return (
        <div className="name-tag" onClick={this.openUserCard.bind(this)}>
          <div className="name-tag_alias">
            <div className="ellipsis">{message.sender.name}</div>
            <ComGroupAlias user={message.sender} session={session} />
          </div>
          {!isEqualEmployee(message.sender, currentEmployee) && (
            <>
              {/* <div className="tag">
                <UserTag userInfo={message.sender as Employee} currentEmployee={currentEmployee} />
              </div> */}
              <div>{tagsNode(message.sender.labelInfoList)}</div>
              {isGroupChatVisibleUnit(session) && message.sender.unitName && (
                <div className="unitName">
                  @{message.sender.unitName}
                  {titleName}
                </div>
              )}
            </>
          )}
        </div>
      );
    }
    if ([SessionType.MEETING_GROUP, SessionType.LIVE_MEETING_GROUP].includes(session.sessionType)) {
      const { selectedSession } = this.props;
      // let tempRosters = Object.values((selectedSession.info as any).rosters || []);
      let tempRosters = Object.values(((selectedSession.info as any) as any).rosters || []);
      const rosters: any[] = tempRosters.map((item: any) => {
        const user = { ...item?.info, identity: item.identity } as any;
        return user;
      });
      let name = message.sender.name;
      let unitName = message.sender.unitName;
      let liveTagName = "";
      const privateSender = message?.to && isEqualEmployee(message.sender, currentEmployee);
      if (session.sessionType === SessionType.MEETING_GROUP) {
        if (privateSender) {
          name = message.to.userName;
          unitName = message.to.unitName;
        } else {
          rosters.map((item: any) => {
            item.clientType = (item.clientType || "").toLowerCase();
            if (item.clientType === "windows") {
              item.clientType = ClientType.PC;
            }
            if (item.userId === message.from?.pin && item.clientType === message.from?.clientType) {
              name = item.name;
              unitName = item.desc;
            }
          });
        }
        if ((message as any)?.source === "live") {
          liveTagName = "直播成员";
        }
      }
      return (
        <div className="name-tag meeting" onClick={this.openUserCard.bind(this)}>
          {privateSender && <span>发送给：</span>}
          <div className="name-tag_alias">
            <div className="ellipsis">{name}</div>
          </div>
          {session.sessionType === SessionType.MEETING_GROUP ? (
            <div className="unitName_meeting">{`@${unitName}`}</div>
          ) : unitName && !!message.statusType ? (
            <div className="unitName_meeting admin">{`(${unitName})`}</div>
          ) : null}
          {message?.to && <div style={{ color: "#FF5E27" }}>（私聊）</div>}
          {liveTagName && <div style={{ marginLeft: "10px" }}>{LiveStatusTag(liveTagName)}</div>}
        </div>
      );
    }
  }

  /**
   * 消息已准备好发送
   * @param param
   */
  messageReady = (param: { beginSend: boolean; messageExtend: any }) => {
    this.setState({
      messageExtend: param.messageExtend,
      beginSend: param.beginSend
    });
  };

  getSendType() {
    const { message, currentEmployee, selectedSession } = this.props;
    return getMessageSendType(message, currentEmployee, selectedSession);
  }

  getMessageItemProps(message: any, sendType: MessageSendType): any {
    return {
      message: message,
      sendType: sendType,
      sessionType: this.props.selectedSession.sessionType,
      onReady: this.messageReady,
      refreshMessageBox: this.props.refreshMessageBox
    };
  }

  // eslint-disable-next-line complexity
  getChatMessageNode(sendType: MessageSendType): ReactNode {
    const {
      currentEmployee,
      message,
      selectedSession,
      isInviteForward,
      modalMessages
    } = this.props;
    const isSupport = checkMessageSupport(message);
    if (!isSupport) {
      return <UnSupport message={message} />;
    }
    const props = this.getMessageItemProps(message, sendType);
    if (message.revoke === 1) {
      // 该消息已撤回
      return <Revoke {...props} />;
    }
    const { sText = "", sMid = -1 } = this.props;
    switch (message.type) {
      case ChatMessageType.TEXT:
        if (message.subType && message.subType === ChatMessageType.QUICK_REPLY) {
          return (
            <QuickReplyCard {...props}>
              <Text
                {...props}
                sText={sText}
                sMid={sMid}
                isShowTag={false}
                isInviteForward={isInviteForward}
                modalMessages={modalMessages}
              />
            </QuickReplyCard>
          );
        }
        // 常用语
        if (message.subType && message.subType === ChatMessageType.QUICK_EMOJI_REPLY) {
          return (
            <ReplyEmojiCard {...props}>
              <Text
                {...props}
                sText={sText}
                sMid={sMid}
                isShowTag={false}
                isInviteForward={isInviteForward}
                modalMessages={modalMessages}
              />
            </ReplyEmojiCard>
          );
        }
        if ((message as any).nativeId === "share_link") {
          return <HttpCard {...props} />;
        }
        if ((message as any).meetingCard && (message as any).meetingCard.meetingId) {
          return <MeetingInviteCard {...props} />;
        }
        return (
          <Text
            {...props}
            sText={sText}
            sMid={sMid}
            isShowTag={true}
            isInviteForward={isInviteForward}
            modalMessages={modalMessages}
          />
        );
      case ChatMessageType.IMAGE:
        return <Image {...props} isInviteForward={isInviteForward} modalMessages={modalMessages} />;
      case ChatMessageType.FILE: {
        if (props.sendType === MessageSendType.OWNER || props.sendType === MessageSendType.SELF) {
          if (
            !isSameClient(message) ||
            (isFocusEnv() && !message.downLocalPath && !message.upLocalPath)
          ) {
            return <DownloadFile {...props} />;
          } else {
            return <UploadFile {...props} />;
          }
        } else {
          return <DownloadFile {...props} />;
        }
      }
      case (ChatMessageType as any).EGOV_FILE: {
        if (props.sendType === MessageSendType.OWNER || props.sendType === MessageSendType.SELF) {
          if (
            !isSameClient(message) ||
            (isFocusEnv() && !message.downLocalPath && !message.upLocalPath)
          ) {
            return <DownloadFile {...props} />;
          } else {
            return <UploadFile {...props} />;
          }
        } else {
          return <DownloadFile {...props} />;
        }
      }
      case ChatMessageType.VIDEO:
        return <Video {...props} />;
      case ChatMessageType.VOICE:
        return <Voice {...props} />;
      case ChatMessageType.TEMPLATE2:
        return <Share {...props} />;
      case ChatMessageType.JOYSPACEFILE:
        return <JoyspaceFile {...props} />;
      case ChatMessageType.JOYSPACEFOLDER:
        return <JoyspaceFolder {...props} />;
      // 组通知
      case ChatMessageType.GROUPNOTICE:
        return <GroupNotificationCard selectedSession={this.props.selectedSession} {...props} />;
      // @ts-ignore
      case "unified_notice_message":
        if (!isShowOldNoticeCard(message) || isShowFakeNoticeCard(message)) {
          return <AINoticeCard {...props} />;
        }
        return <NoticeCard {...props} />;
      case ChatMessageType.SYS:
        return <SysMessage {...props} />;
      case ChatMessageType.SOLITAIRE:
        return <SolitaireCard selectedSession={selectedSession} {...props} />;
      case ChatMessageType.LOCATION_JD:
        return <Location {...props} />;
      default:
        return null;
    }
  }

  openUserCard() {
    const { selectedSession, message, currentEmployee, t, groupRosterIdentity } = this.props;
    const { from } = message;
    if (selectedSession?.isNotice) {
      return;
    } else if (
      [SessionType.MEETING_GROUP, SessionType.LIVE_MEETING_GROUP].includes(
        selectedSession.sessionType
      )
    ) {
      // FocusSDK.openUserCard({
      //   type: UserCardType.CustomUser,
      //   userId: from?.pin,
      //   teamId: from.teamId,
      //   appId: from.app
      // });
      return;
    } else {
      // 如果群成员并且禁止了查看群成员名片
      if (
        !isEqualEmployee(currentEmployee, uidToEmployee(from) as Employee) &&
        isGroupOrdinary(groupRosterIdentity) &&
        !isCardViewGroupSession(selectedSession)
      ) {
        toast.warn(t("can_not_open_user_card_tip"));
        return false;
      }
      analysisLog("Xtbg_Msg_Dialog", "ViewMember");
      Bus.emit("app:toggle-user-card-modal:show", {
        visible: true,
        type: UserCardType.User,
        userId: from?.pin,
        teamId: from.teamId,
        appId: from.app
      });
    }
  }

  getHeadPortrait(): ReactNode {
    const { selectedSession, message, prevMessage, isLiveMeetingChat } = this.props;
    if (isLiveMeetingChat) {
      return null;
    }
    if (isAIChatSession(selectedSession)) {
      return null;
    }
    if (isOrgChatSession(selectedSession)) {
      return null;
    }
    let msg: any = prevMessage;
    if (!prevMessage || prevMessage.revoke === 1 || msg.plusList) {
      return (
        <HeadPortrait
          member={selectedSession}
          width="32px"
          height="32px"
          fontSize="13px"
          imgUrl={message.sender.avatar}
          name={message.sender.name}
          type={selectedSession.sessionType}
          isUnFollow={true}
          showType={HeadShowType.SESSION_LIST}
          onItemClick={this.openUserCard.bind(this)}
        />
      );
    }
    return null;
  }

  getMsgItemClass(sendType: MessageSendType) {
    return classNames({
      "message-box": true,
      reverse:
        !this.props.isLiveMeetingChat &&
        [MessageSendType.OWNER, MessageSendType.SELF].includes(sendType),
      "content-height": !this.props.prevMessage,
      group: this.props.selectedSession.sessionType === SessionType.GROUP,
      "select-more": this.props.selectMore,
      selectChatItem: this.state.selectChatItem && this.props.selectMore
    });
  }

  getContentItemClass(sendType: MessageSendType, session: Session) {
    return classNames({
      "row-item-wrap": true,
      "row-item-wrap-max":
        sendType !== MessageSendType.OWNER &&
        sendType !== MessageSendType.SELF &&
        isAIChatSession(session),
      owner: sendType === MessageSendType.OWNER || sendType === MessageSendType.SELF,
      isLive: this.props.isLiveMeetingChat,
      "has-emoji": this.state.hasEmoji,
      other: sendType === MessageSendType.OTHER
    });
  }

  getMsgControlClass() {
    const { selectedSession, message } = this.props;
    return classNames({
      "chat-item-control": true,
      "chat-item-control_flex_end":
        selectedSession.isSecret || message.statusType === MessageStatus.EXPIRED
    });
  }

  getStyleObj(sendType: MessageSendType, session: Session): any {
    const { message, selectedSession } = this.props;
    if (message.type !== ChatMessageType.VOICE || selectedSession.isSecret) {
      return {};
    }
    const isOwnerVoice = sendType === MessageSendType.OWNER || sendType === MessageSendType.SELF;
    const voiceMsgWidth = getVoiceMsgWidth(message);
    return isOwnerVoice
      ? selectedSession.isSingle
        ? { position: "absolute", marginTop: "24px", right: voiceMsgWidth + 64 }
        : {}
      : { position: "absolute", left: voiceMsgWidth + 64 };
  }

  showOperate = () => {
    const message = this.props.message;
    if (message.revoke || !message.mid) {
      // 撤回的消息是没有操作权限的
      return;
    }
    this.props.setCurrentMessageId(message.id);
    const isNotLock = this.props.getLock();
    if (isNotLock) {
      if (this.state.showOperate) {
        return;
      }
      this.setState({ showOperate: true });
    }
  };

  showQuestionOperate = () => {
    const message = this.props.message;
    this.props.setCurrentMessageId(message.id);
    const isNotLock = this.props.getLock();
    if (isNotLock) {
      if (this.state.showOperate) {
        return;
      }
      this.setState({ showOperate: true });
    }
  };
  handleSelectMore = () => {
    const { selectChatItem } = this.state;
    const { message, messages, selectMore, selectedSession } = this.props;
    const isSupport = checkMessageSupport(message);
    // const isNotSelect = selectedSession.isSecret
    //     ? !isSupport
    //     : !isSupport || message.type === ChatMessageType.VOICE;
    // if (isNotSelect) {
    //     return;
    // }
    if (!isSupport) {
      return;
    }
    if (messages.length > 99 && !selectChatItem) {
      toast.error("沟通记录最多可选100条");
      return;
    }
    if (selectMore) {
      this.setState(
        {
          selectChatItem: !selectChatItem
        },
        () => {
          const { selectChatItem } = this.state;
          if (selectChatItem) {
            messages.push(message);
            let newMessages = messages.sort((item1, item2) => item1.timestamp - item2.timestamp);
            this.props.updateMessages({ messages: newMessages });
          } else {
            let newMessages = messages.filter((item) => item.id !== message.id);
            newMessages = newMessages.sort((item1, item2) => item1.timestamp - item2.timestamp);
            this.props.updateMessages({ messages: newMessages });
          }
        }
      );
    }
  };
  maskShow = () => {
    const mask = document.getElementById("message-box-container-scroll");
    if (!mask) return;
    mask.style.overflowY = "";
  };
  maskHide = () => {
    const mask = document.getElementById("message-box-container-scroll");
    if (!mask) return;
    mask.style.overflowY = "hidden";
  };
  unLock = () => {
    if (this.props?.shareRecords) return;
    this.onMouseLeave();
    this.props.unLock();
    this.maskShow();
    this.setState({ visible: false });
  };

  onMouseLeave = () => {
    this.props.setCurrentMessageId("");
    if (!this.props.getLock()) {
      return;
    }
    this.setState({ showOperate: false });
  };

  onVisibleChange = (flag: boolean) => {
    // if (this.props.message.type === ChatMessageType.GROUPNOTICE) {
    //     return;
    // }
    // this.onMouseLeave();
    if (this.props.selectMore) {
      return;
    }
    if (this.props?.shareRecords) return;
    const { message, selectedSession } = this.props;
    const isAI = isAIChatSession(selectedSession);
    if (isAI) {
      return;
    }
    if (isTemp2CommonCardMsg(message)) {
      const { common_card = {} } = (message as any).data[0];
      const msgOptionConfig = common_card.msgOptionConfig || {};
      const values = Object.values(msgOptionConfig);
      const show = values.some((item) => item);
      if (!show) {
        return;
      }
    }
    this.props.unLock();
    Bus.off("message-item-chatitem").on("message-item-chatitem", (data) => {
      this.setState({ visible: false });
      this.maskShow();
    });
    this.setState({ visible: flag });
    if (flag) {
      this.maskHide();
    } else {
      this.maskShow();
    }
  };
  getTimeRowPart = () => {
    const { prevMessage, sendTime, message, selectedSession } = this.props;
    let msg: any = prevMessage;
    if (!prevMessage || prevMessage?.revoke === 1 || msg.plusList) {
      return (
        <div
          className={`time-row ${
            isAINoticeSession(selectedSession) &&
            (!isShowOldNoticeCard(message) || isShowFakeNoticeCard(message))
              ? "marL"
              : ""
          }`}
        >
          {this.getSendUserName()}
          {/* <Tooltip title={sendTime}>{sendTime}</Tooltip> */}
          {/* <div>{sendTime}</div> */}
        </div>
      );
    }
    return null;
  };

  getSfPart = () => {
    const { message, prevMessage, isLiveMeetingChat, selectedSession } = this.props;
    if (isOrgChatSession(selectedSession)) {
      return null;
    }
    let msg: any = prevMessage;
    if (
      isAIChatSession(selectedSession) ||
      isLiveMeetingChat ||
      isShareHintMultiMessage(message) ||
      !prevMessage ||
      prevMessage?.revoke === 1 ||
      msg.plusList
    ) {
      return null;
    }
    return (
      <Tooltip title={sf(message.timestamp)}>
        <div className="sf">{sf(message.timestamp)}</div>
      </Tooltip>
    );
  };

  getSelectMore = () => {
    const { selectMore, message, selectedSession } = this.props;
    const { selectChatItem } = this.state;
    // const sendType = this.getSendType();
    // let diffDom: any = this.getChatMessageNode(sendType);
    const isSupport = checkMessageSupport(message);
    // @ts-ignore
    // const isNotSelect = selectedSession.isSecret
    //     ? !isSupport
    //     : !isSupport || message.type === ChatMessageType.VOICE;
    if (!isSupport || message.statusType === MessageStatus.EXPIRED) {
      return (
        selectMore && (
          <div className="checkbox-wrapper">
            <Checkbox disabled />
          </div>
        )
      );
    }
    return (
      selectMore && (
        <div className="checkbox-wrapper">
          <Checkbox checked={selectChatItem} />
        </div>
      )
    );
  };

  handleAvatarRightClick = (visible: boolean) => {
    const { selectedSession } = this.props;
    if (selectedSession.isSingle) {
      this.setState({ avatarRightClick: false });
      return;
    }
    // console.log('avatarRightClick', visible);
    this.setState({ avatarRightClick: visible });
  };
  // 右键AT
  userSelectOk = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    const { message, selectedSession } = this.props;
    const alias = getUserAlias(message.sender, selectedSession);
    const data = [
      {
        id: `${message.from.pin}:${message.from.app}:${message.from.teamId}:user`,
        type: "user",
        name: message.nickName,
        alias: alias
      }
    ];
    Bus.emit("message:mentionUser", data);
    this.setState({ avatarRightClick: false });
  };
  // eslint-disable-next-line @typescript-eslint/member-ordering
  menu = () => {
    const { message, selectedSession } = this.props;
    let alias = getUserAlias(message.sender, selectedSession);
    alias = alias ? `（${alias}）` : "";
    return (
      <Menu>
        <Menu.Item>
          <a
            onClick={(e) => {
              this.userSelectOk(e);
            }}
            style={{ fontSize: 14 }}
          >
            @ {this.props.message.nickName}
            {alias}
          </a>
        </Menu.Item>
      </Menu>
    );
  };
  onSendStatus = (status: MessageStatus) => {
    // 接收控制发送消息组件的状态，只有不是INIT的状态才会接收
    if (status !== MessageStatus.INIT) {
      // setSendStatus(status);
      return;
    }
  };
  handleQuickChange = (data: any) => {
    const { updateSessionMessageMid, message } = this.props;
    updateSessionMessageMid({
      sessionId: message.sessionId,
      sendResult: {
        body: { ...message, ...data }
      }
    });
  };

  handleAIAnswerTimeout = () => {
    const { dealStopQuestions, message, updateSessionMessageMid } = this.props;
    toast.warn("请求超时，请稍后重试");
    dealStopQuestions({
      id: message.id
    });
    updateSessionMessageMid({
      sessionId: message.sessionId,
      sendResult: {
        body: { ...message, flag: "end", content: "请求超时，请稍后重试" }
      }
    });
  };

  public render() {
    const {
      message,
      selectMore,
      selectedSession,
      currentEmployee,
      refreshMessageBox,
      sText = "",
      sMid = -1
    } = this.props;
    if (!message.type) {
      return null;
    }
    const { messageExtend, beginSend, visible, showOperate, avatarRightClick } = this.state;
    const sendType = this.getSendType();
    const isCancelMerge = (message as any)?.mediaState && (message as any)?.mediaState === 4096;
    const itemEventConfig = {
      onMouseEnter: !isAIChatSession(selectedSession) ? this.showOperate : this.showQuestionOperate,
      onClick:
        !message.plusList &&
        message.type !== ChatMessageType.SOLITAIRE &&
        message.type !== ChatMessageType.GROUPNOTICE
          ? this.handleSelectMore
          : undefined,
      onMouseLeave: this.onMouseLeave,
      className: this.getMsgItemClass(sendType)
    };
    if (message.id) {
      return (
        <div
          ref={this.wrapRef}
          className={`msg-item-col ${![MessageSendType.OTHER].includes(sendType) ? "reverse" : ""}`}
        >
          {/* 消息聚合 */}
          {(selectedSession?.isGroup || selectedSession?.isMeeting) === true && message.plusList ? (
            <Dropdown
              overlay={() => {
                return (
                  <Control
                    {...this.props}
                    unLock={this.unLock}
                    showOperateBox={visible && !selectMore}
                    showAI={true}
                  />
                );
              }}
              trigger={["contextMenu"]}
              visible={visible}
              onVisibleChange={this.onVisibleChange}
            >
              <div>
                <ChatAggregation
                  {...this.props}
                  message={message}
                  selectedSession={selectedSession}
                  currentEmployee={currentEmployee}
                  sendType={sendType}
                  sessionType={selectedSession.sessionType}
                  onReady={this.messageReady}
                  sText={sText}
                  sMid={sMid}
                />
              </div>
            </Dropdown>
          ) : (
            // </div>
            <div
              {...itemEventConfig}
              id={`item-${message.id}-${message.timestamp}`}
              data-message={this.isVisibleOfText() ? JSON.stringify(message) : null}
            >
              {!message.plusList &&
                message.type !== ChatMessageType.SOLITAIRE &&
                message.type !== ChatMessageType.GROUPNOTICE && <div>{this.getSelectMore()}</div>}
              <div
                className={`content-row ${
                  isOrgChatSession(selectedSession) && isOrgNoticeImageTextCardMessage(message)
                    ? "center"
                    : ""
                }`}
              >
                {/* 右键@ */}
                {isAINoticeSession(selectedSession) &&
                (!isShowOldNoticeCard(message) || isShowFakeNoticeCard(message)) ? null : (
                  <>
                    <Dropdown
                      overlay={this.menu}
                      trigger={["contextMenu"]}
                      visible={avatarRightClick}
                      onVisibleChange={(visible) => this.handleAvatarRightClick(visible)}
                    >
                      <div>{this.getHeadPortrait()}</div>
                    </Dropdown>

                    {this.getSfPart()}
                  </>
                )}
                <Dropdown
                  overlay={() => {
                    return (
                      <Control
                        {...this.props}
                        unLock={this.unLock}
                        showOperateBox={visible && !selectMore}
                        isRightClick={visible}
                      />
                    );
                  }}
                  trigger={["contextMenu"]}
                  visible={visible && !this.props?.shareRecords}
                  onVisibleChange={this.onVisibleChange}
                >
                  <div className={this.getContentItemClass(sendType, selectedSession)}>
                    {this.getTimeRowPart()}
                    <div
                      className={`content-container-202 ${
                        isAIChatSession(selectedSession) ? "ai-row" : ""
                      }`}
                    >
                      <div
                        className={`content-col ${
                          (message as any).flag ? `text-${(message as any).flag}` : ""
                        }`}
                      >
                        {/* 消息本体 */}
                        {this.getChatMessageNode(sendType)} 
                        {/* ai小尾巴 */}
                        {showIntentRootTail(message) ? <AiIntentTail message={message} /> : null}
                        {isAIChatSession(selectedSession) &&
                        (message as any).flag === "end" &&
                        sendType !== MessageSendType.OWNER &&
                        sendType !== MessageSendType.SELF ? (
                          <QuestionControl {...this.props} showOperateBox={showOperate} />
                        ) : null}
                        {(message as any)?.flag === "loading" && (
                          <AiLoading
                            delay={30 * 1000}
                            onTimeout={() => this.handleAIAnswerTimeout()}
                          />
                        )}
                        {/* 将hover显示的内容以及已读未读状态放到内部，并采用绝对定位 */}
                        {isShareHintMultiMessage(message) ? null : !selectMore ? (
                        <>
                        {!selectedSession.isSecret &&
                            message.type !== ChatMessageType.VOICE &&
                            message.statusType !== MessageStatus.EXPIRED && (
                              <Control
                                {...this.props}
                                unLock={this.unLock}
                                showOperateBox={showOperate}
                                showAI={true}
                                hasReachedMax={this.state.hasReachedMax}
                              />
                            )}
                          <MessageControl
                            sendType={sendType}
                            message={message}
                            sessionType={selectedSession.sessionType}
                            beginSend={beginSend}
                            messageExtend={messageExtend}
                            onSendStatus={this.onSendStatus}
                          />
                        </>
                      ) : (
                        <div
                          style={{
                            minWidth: `${selectedSession.isSecret ? "36px" : "0px"}`
                          }}
                        />
                      )}
                      </div>
                      {/* hover显示的内容以及已读未读状态 原本位置 */}
                      {/* TODO: 单聊密聊显示 */}
                      {selectedSession?.isSecret && message.expire ? (
                        <CountDown
                          message={message}
                          sendType={sendType}
                          refreshMessageBox={refreshMessageBox}
                        />
                      ) : null}
                    </div>
                    <div className="extend-area">
                      {/* {message.type === ChatMessageType.FILE &&
                        isEqualEmployee(message.sender, currentEmployee) &&
                        selectedSession.isGroup && !selectedSession.isSecret && <UploadWithDetailBtn {...this.props} />} */}
                      {isEqualEmployee(message.sender, currentEmployee) &&
                        selectedSession.isGroup &&
                        message.type !== ChatMessageType.SOLITAIRE &&
                        message.type !== ChatMessageType.GROUPNOTICE &&
                        message.type !== ChatMessageType.FILE &&
                        message.type !== ChatMessageType.EGOV_FILE &&
                        (selectedSession.info as any).msgDongRead === 1 && (
                          <MessageDongReadStatusBtn { ...this.props } />
                        )}
                    </div>
                  </div>
                </Dropdown>
              </div>
            </div>
          )}
          {isCancelMerge ? cancelMergeTag("已取消智能聚合") : null}
        </div>
      );
    }
    return <div />;
  }
}

function mapStateToProps({ chat }: any) {
  const {
    selectedSession,
    currentEmployee,
    selectMore,
    messages,
    sessionMessageMap
  } = chat as ChatState;
  return { selectedSession, currentEmployee, selectMore, messages, sessionMessageMap };
}

function mapDispatchToProps(dispatch: any) {
  return {
    async deleteSessionMessage(data: { message: ChatMessage }) {
      await dispatch({ type: "chat/deleteSessionMessage", payload: data });
    },
    toggleUserCardModal(payload: UserCardPayload) {
      dispatch({ type: "app/toggleUserCardModal", payload });
    },
    getEbookDeptInfo(data: any) {
      dispatch({ type: "ebook/getEbookDeptInfo", payload: data });
    },
    updateMessages(data: { messages: ChatMessage[] }) {
      dispatch({ type: "chat/updateMessages", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation("chat")(ChatItem));
